import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import { SITE_KEY } from '../../../constants'

//Components
import { FaIdCard, FaSignInAlt, FaShieldAlt } from "react-icons/fa"
import AdminService from "../../../services/admin_services"
import token_services from "../../../services/token_services"

class AdminLogin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            token: null,
            email: null,
            password: null,
            twoFA: null,
            display: false,
        }
    }

    componentDidMount = async() => {
        const jwt = token_services.getLocalAccessToken()
        if(jwt)
            window.location.href="/admin"
    }

    onVerifyCaptcha = (token) => {
        this.setState({ token })
    }

    login = async () => {
        if (!this.state.email || !this.state.password)
            NotificationManager.error('Missing credentials')
        else if (!this.state.token)
            this.setState({ error: 'reCaptcha missing', info: null, success: false })
        else {
            try {
                await AdminService.login(this.state.email, this.state.password, this.state.token)
                this.setState({display: true})
            } catch (e) {
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    login2fa = async () => {
        if (!this.state.email || !this.state.password)
            NotificationManager.error('Missing credentials')
        else if (!this.state.twoFA)
            this.setState({ error: '2FA missing', info: null, success: false })
        else {
            try {
                await AdminService.login2fa(this.state.email, this.state.password, this.state.twoFA)
                window.location.href = "/admin"
            } catch (e) {
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                        {/* Header */}
                        <div className="text-center">
                            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl mb-4">
                                <FaShieldAlt className="text-3xl text-white" />
                            </div>
                            <h2 className="text-3xl font-bold text-gray-900 mb-2">Admin Access</h2>
                            <p className="text-gray-600">Sign in to access administration tools</p>
                        </div>

                        {/* Form */}
                        <div className="space-y-4">
                            <div>
                                <input 
                                    type="email" 
                                    placeholder="Email address" 
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                />
                            </div>
                            
                            <div>
                                <input 
                                    type="password" 
                                    placeholder="Password" 
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                />
                            </div>

                            <div className="flex justify-center">
                                <HCaptcha
                                    sitekey={SITE_KEY}
                                    onVerify={this.onVerifyCaptcha}
                                />
                            </div>

                            {!this.state.display && (
                                <button 
                                    onClick={this.login}
                                    className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                                >
                                    Request 2FA <FaIdCard />
                                </button>
                            )}

                            {this.state.display && (
                                <>
                                    <div>
                                        <input 
                                            type="number" 
                                            placeholder="2FA Code from Email" 
                                            onChange={(e) => this.setState({ twoFA: e.target.value })}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
                                        />
                                    </div>
                                    <button 
                                        onClick={this.login2fa}
                                        className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                                    >
                                        Sign In <FaSignInAlt />
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }
}

export default withTranslation()(AdminLogin)